import React, { useEffect, useState } from "react";
import { clockTime, useAgencyInfo } from "./common";
import { fontClass } from "../boardSchema";

const AgencyHeaderWidget = ({ config = {}, agency, board }) => {
  const info = useAgencyInfo(agency);
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    if (config.showClock === false) return undefined;
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, [config.showClock]);

  const name = board?.boardName || info.name || agency || "Station Board";
  const accent = board?.theme?.accent;

  return (
    <div className={`sb-header${fontClass(config.font)}`} style={accent ? { borderColor: accent } : undefined}>
      <div className="sb-header-left">
        {config.showLogo !== false && info.logo ? (
          <img className="sb-header-logo" src={info.logo} alt={name} />
        ) : null}
        {config.showAgencyName !== false && (
          <div className="sb-header-name">{name}</div>
        )}
      </div>
      {config.showClock !== false && (
        <div className="sb-header-clock">
          {clockTime(now, { timeFormat: config.timeFormat })}
        </div>
      )}
    </div>
  );
};

export default AgencyHeaderWidget;
